import Slider from "./slider_controller"
import {
    TimelineLite,
    TweenLite,
    // easing
    Power2,
} from "gsap/all"

export default class extends Slider {

    static targets = [
        "slide",
        "bullets",
        "thumbs",
        "progressBar",
        "indicatorCurrent",
        "indicatorMax",
        "slideText",
        "slidesTextWrapper",
    ]

    initialize() {
        super.initialize()
        if ( this.$slideTextItems.length && this.autoTextHeight ) {
            this.setSlidesTextWrapperHeight()
        }
    }

    get count() {
        return this.$slideTextItems.length || this.$slideItems.length
    }

    get $slideTextsWrapper() {
        return this.slidesTextWrapperTarget
    }

    setSlidesTextWrapperHeight($quote) {
        $quote = $quote !== undefined ? $quote : this.$slideTextItems[0]
        TweenLite.set(this.$slideTextsWrapper, {height: this.getSlideTextHeight($quote)})
    }

    getSlideTextHeight($quote) {
        //const quotesPartPt = parseInt(window.getComputedStyle(this.$slideTextsWrapper, null).getPropertyValue('padding-top'))
        //const quotesPartPb = parseInt(window.getComputedStyle(this.$slideTextsWrapper, null).getPropertyValue('padding-bottom'))
        //const quotesPartH = quotesPartPt + quotesPartPb
        return $quote.clientHeight + "px"
    }

    get $slideTextItems() {
        return this.slideTextTargets
    }

    get autoTextHeight(){
        const value = this.data.get("autoTextHeight")
        return value !== undefined ? parseInt(value) : 1
    }

    textAnimation() {

        const tl = new TimelineLite()

        const $nextSlide = this.$slideTextItems[this.currentIndex]
        const $prevSlide = this.$slideTextItems[this.prevIndex]
        const $nextChilds = [...$nextSlide.querySelectorAll("[data-slide-child]")]

        /*console.log("$prevSlide", $prevSlide)
        console.log("$nextSlide", $nextSlide)
        console.log("$nextChilds", $nextChilds)
        return*/

        tl.set($nextSlide, {
            opacity: 1,
            zIndex: 2 * this.timesClicked
        })
        tl.set($nextChilds, {
            opacity: 0,
            y: "30px",
        })
        tl.add("hide")
        tl.to($prevSlide, 0.4, {
            opacity: 0
        }, "hide")
        if ( this.autoTextHeight ) {
            tl.to(this.$slideTextsWrapper, 1, {
                height: this.getSlideTextHeight($nextSlide),
                ease: Power2.easeOut
            }, "hide")
        }
        tl.staggerTo($nextChilds, 0.4, {
            opacity: 1,
            y: 0,
            rotation: 0,
        }, 0.1, "hide+=0.2")
        tl.add("now")

        return tl
    }

    animate() {
        console.log("animate")
        const tl = new TimelineLite({})
        // Image slide
        tl.add("start")
        // Quote
        if (this.$bullets.length) {
            tl.add(this.bulletsAnimation(), "start")
        }
        if (this.$thumbs.length) {
            tl.add(this.thumbsAnimation(), "start")
        }
        if ( this.$slideTextItems.length ) {
            tl.add(this.textAnimation(), "start")
        }
        if ( this.$slideItems.length ) {
            tl.add(this.photoAnimation(), "start")
        }

        console.log("duration", tl.duration())
    }


}
